import script from "./ZIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ZIcon.vue?vue&type=script&setup=true&lang=js"

import "./ZIcon.vue?vue&type=style&index=0&id=bc5dcf50&lang=scss"

const __exports__ = script;

export default __exports__